import { PriceVariantFragment } from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import { PriceVariant } from '@/integrations/crystallize/types';

export function parsePriceVariant(
  priceVariant?: PriceVariantFragment | null,
): PriceVariant | undefined {
  if (!priceVariant?.currency || priceVariant.price === null || priceVariant.price === undefined) {
    return undefined;
  }

  return {
    price: priceVariant.price,
    currency: priceVariant.currency,
    identifier: priceVariant.identifier,
  };
}
